import { FC } from 'react';
import { DigitalForms } from '@wetags/digital-forms';
import { useTranslation } from '@frontend/i18n';
import { ContentLoader, Modal } from '@frontend/design-system';
import { useEnhancedSendFormsFlow } from '../../hooks';
import { useSendFormsStore } from '../../providers';
import { SendFormStep } from '../../types';
import SendFormsFooter from '../footer/footer.component';
import SendFormsHeader from '../header/header.component';
import AddMoreDetailsStep from './appointment-selection/appointment-selection-enhanced.component';
import AppointmentSelectionStep from './appointment-selection/appointment-selection.component';
import { DeliveryDetailComponent } from './delivery-method-selection/delivery-detail-component';
import LocationSelectionStep from './location-selection/location-selection.component';
import RecipientSelectionStep from './recipient-selection/recipient-selection.component';
import SelectDocumentStep from './select-document/select-document.component';
import SelectedDeliveryMode from './selected-delivery-mode/selected-delivery-mode.component';
import { innerContainerStyle } from './send-forms-steps.styles';

const Steps: FC = () => {
  const { t } = useTranslation('digital-forms-sending-experience');
  const { currentStep, areFormsEnabledLocationIdsSet } = useSendFormsStore([
    'currentStep',
    'areFormsEnabledLocationIdsSet',
  ]);
  const [isEnhancedFlowEnabled, isLoading] = useEnhancedSendFormsFlow();

  if (!areFormsEnabledLocationIdsSet || isLoading) {
    return <ContentLoader show message={t('Initializing...')} />;
  }

  switch (currentStep) {
    case SendFormStep.SELECT_LOCATION:
      return <LocationSelectionStep />;

    case SendFormStep.SELECT_CONTACT:
      return <RecipientSelectionStep />;

    case SendFormStep.SELECT_APPOINTMENT:
      return isEnhancedFlowEnabled ? <AddMoreDetailsStep /> : <AppointmentSelectionStep />;

    case SendFormStep.SELECT_DELIVERY_METHOD:
      return <DeliveryDetailComponent />;

    case SendFormStep.SELECT_DOCUMENT:
      return <SelectDocumentStep />;

    case SendFormStep.SELECTED_MESSAGE_MODE:
      return <SelectedDeliveryMode />;

    default:
      return null;
  }
};

const SendFormsSteps: FC = () => {
  const { t } = useTranslation('digital-forms-sending-experience');
  const { isGeneratingSolicitedLink } = useSendFormsStore(['isGeneratingSolicitedLink']);

  const [isEnhancedSendFormsFlowEnabled, isWetagLoading] = DigitalForms.useWetag('send-forms-enhanced-flow');
  console.log(
    'Wetag "send-forms-enhanced-flow" is',
    isWetagLoading ? 'loading' : isEnhancedSendFormsFlowEnabled ? 'ENABLED' : 'DISABLED'
  );

  return (
    <>
      <SendFormsHeader />
      <Modal.Body>
        <section css={innerContainerStyle}>
          <Steps />
        </section>
      </Modal.Body>
      <SendFormsFooter />
      <ContentLoader show={isGeneratingSolicitedLink} message={t('Generating link...')} />
    </>
  );
};

export default SendFormsSteps;
